// export { default } from './api'
export * from './api'
//这里面对应着四个方法 get put post del四个方法

import { http,get,post,put,del} from './api'


const apiServe = {
    // 确定好什么方法之后，直接传递参数过来就行，在这边写get post put del
    getIndexData: (data, method) => get('/api/index/index', data),
    postProjectHData: (data, method) => post('/api/index/project', data),
    postNewsData: (data, method) => post('/api/index/news', data),
    postNewsDetailData: (data, method) => post('/api/index/news_info', data),
    postNewsKeyData: (data, method) => post('/api/index/news_tag', data),
    postFormData: (data, method) => post('/api/index/sub_company', data),
    getHrData: (data, method) => get('/api/index/job', data),
    getHistoryData: (data, method) => get('/api/index/history', data),
    getProjectsData: (data, method) => get('/api/index/product', data),
}

export default apiServe